const CommitmentSection = ({ register, errors, watch, discount, onApplyVoucher, children }) => {

  const voucherCode = watch("voucherCode");

  return (
    <div className="bg-light p-3 mt-2 rounded">

      {discount && (
        <div className={`d-flex align-items-center pb-3`}>
          <div className="col-8">
            <input
              {...register("voucherCode")}
              type="text"
              className="form-control voucher w-100"
              placeholder="Enter Voucher Code"
              // disabled={isVoucherDisable}
            />
          </div>
          <div className="col-4">
            <button
              type="button"
              // disabled={isVoucherDisable}
              className={`btn btn-danger w-100 rounded-0 rounded-end`}
              style={{ height:44 }}
              onClick={() => onApplyVoucher(voucherCode)}
            >
              Apply
            </button>
          </div>
        </div>        
      )}

      <label className="d-flex align-items-center gap-2">
        <input
          type="checkbox"
          {...register("confirm", {
            required: "You must agree before submitting",
          })}
          className="mr-2"
        />
        <span className="text-sm">
          We Confirm to Join at Education Festival {new Date().getFullYear()}
        </span>
      </label>

      {errors.confirm && (
        <p className="text-danger mt-1">
          {errors.confirm.message}
        </p>
      )}

      {children && (
        <div className="mt-3">
          {children}
        </div>
      )}      

    </div>
  );
};

export default CommitmentSection;